"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryDetailsPlacement = void 0;
var StoryDetailsPlacement;
(function (StoryDetailsPlacement) {
    StoryDetailsPlacement["StoryDetails"] = "story_details";
})(StoryDetailsPlacement = exports.StoryDetailsPlacement || (exports.StoryDetailsPlacement = {}));
